<script>
import Layout from '@/Shared/layout/default'
import { Link } from '@inertiajs/vue3'

export default {
//   Using a render function...
  layout: (h, page) => h(Layout, [page]),



//   Using shorthand syntax...
  layout: Layout,
}
</script>

<script setup>
defineProps({ user: Object, sites: Object })
</script>

<template>

<div class="flex">
  <!-- <div>
    <h1 class="text-2xl">Welkom Sesayars,</h1>
    <p>All information you will need!</p>
  </div>
    <div class="flex-1"></div> -->
  <div class="flex items-center w-full">
    <h1 class="text-xl font-semibold">Website Portfolio</h1>
  </div>
</div>

<div class="flex flex-wrap gap-4 mt-6">
<template v-for="site in sites">
  <Link :href="'/site/'+site.uuid" class="hover:opacity-70" style="min-width: calc(100% / 5); max-width: calc(100% / 5);">
    <div class="rounded-xl bg-bay w-full h-48" :style="'background:url('+site.image+'); background-size:cover; background-position: center;'"></div>
    <h4 class="font-semibold pb-2 pt-2">{{ site.domain }}</h4>
    <label class="text-sm">{{ site.updated_at }}</label>
  </Link>
</template>
</div>

</template>